import React, { useCallback, useContext, useMemo } from 'react';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getRegion } from 'utils/Region';
import Metrics from 'services/metrics';
import { converter } from 'helpers/converter';
import { creditCardPayway } from 'components/user/MyAccountSelector';
import './styles.scss';
import { getTranslation } from 'utils/getTranslation';
import { UserContext } from 'providers/user.provider';
import { isKidProfile } from 'containers/NewSearchPage/utils/isKidProfile';
import { useProfiles } from 'containers/ProfileManager/hooks/useProfiles';
import { useTranslation } from 'hooks/useTranslation';
import {
  HBO_ACTIVATE_OPTION_TRANSLATION_KEYS,
} from 'containers/HboActivation/constants';
import { useHboEligibleStatus } from 'containers/HboActivation/hooks/useHboEligibleStatus';
import { HBO_COMMUNICATION } from 'routes/RouteConstants';
import { HBO_COMMUNICATION_ORIGIN } from 'containers/HboCommunication/constants';

export const OpcionMenuAdmin = ({ onClose }) => {
  const { profilesEnable } = useProfiles();
  const store = useSelector(state => state);
  const { isAdmin } = useSelector(state => state.user);
  const { isMobile } = useVerifyIsMobile(1367);
  const translations = useSelector(state => state.translations);
  const translationsMetadata = useSelector(
    state => JSON.parse(state?.metadata?.translations)?.language?.[getRegion()],
  );
  const perfiles = useSelector(
    state => state.profilesManager.profilesInfo?.members,
  );
  const { gamification_id } = useSelector(state => state.user);

  const { logout } = useContext(UserContext);
  const { translationMapper } = useTranslation();
  const { isEligible } = useHboEligibleStatus();
  const navigate = useNavigate();
  const location = useLocation();

  const isKids = isKidProfile(perfiles, gamification_id);
  const { NAME_OPTION: hboActivateOptionName } = useMemo(
    () => translationMapper(HBO_ACTIVATE_OPTION_TRANSLATION_KEYS),
    [translationMapper],
  );
  //----------------------------------
  const suscription = `/${getRegion()}/home/user?micuentafull#micuentavtc`;
  //const payment = `/${getRegion()}/home/user?micuentafull#micuentamodificarmediodepago`;
  const myProfile = `/${getRegion()}/home/user?micuentafull#micuentamodifyuser`;
  const count = `/${getRegion()}/home/user?micuentafull#micuentadevices`;
  const parental = `/${getRegion()}/home/user?micuentafull#micuentacontrolpin`;
  const history = `/${getRegion()}/home/user?micuentafull#micuentahistorial`;
  const preference = `/${getRegion()}/home/preference?preference&amp;info=pref`;
  const help = `/${getRegion()}/home/help`;

  const showPaymentOption = creditCardPayway(store);
  const hboActivateOptionLabel = hboActivateOptionName || 'Activar HBO Max';
  const showHboActivateOption = isAdmin && isEligible;

  // functiones

  const closeMenu = () => {
    onClose && onClose();
  };

  const sendMetric = label => {
    Metrics.newEvent({
      eventCategory: 'Mi Cuenta',
      eventAction: 'Click',
      eventLabel: label,
    });
  };

  const handleLogout = () => {
    onClose && onClose();
    logout();
    localStorage.removeItem('epgVersion');
    localStorage.removeItem('epgMenu');
    localStorage.removeItem('epgLineUp');
    localStorage.removeItem('epgChannelGrid');
    localStorage.removeItem('isEmailRegister');
    localStorage.removeItem('getUserInfo');
  };

  // la opcion ya no activa directo; abre la pantalla de comunicacion y la
  // activacion (con su select_content) ocurre en ella
  const handleActivateHbo = useCallback(
    event => {
      event?.preventDefault?.();
      event?.stopPropagation?.();

      sendMetric(hboActivateOptionLabel);
      navigate(HBO_COMMUNICATION, {
        state: {
          hboCommunicationOrigin: HBO_COMMUNICATION_ORIGIN.MENU,
          hboCommunicationReturnTo: `${location.pathname}${location.search}${location.hash}`,
        },
      });
      closeMenu();
    },
    [hboActivateOptionLabel, location, navigate],
  );

  return (
    <>
      {!isKids && profilesEnable && (
        <hr className="menu-avatar-desktop__opt__admin__hr" />
      )}
      <div className="menu-avatar-container-option-my-account">
        {isAdmin && (
          <>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={suscription}
                onClick={() => {
                  sendMetric('Suscripción');
                  closeMenu();
                }}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'suscription',
                  'Suscripción',
                )}{' '}
              </NavLink>
            </li>
             {showHboActivateOption && isMobile && (
              <li className="menu-avatar-desktop__opt__admin">
                <NavLink onClick={handleActivateHbo}>
                  {hboActivateOptionLabel}
                </NavLink>
              </li>
            )}
            {/* <>
              {getRegion() === 'mexico' && showPaymentOption && (
                <li className="menu-avatar-desktop__opt__admin">
                  <NavLink
                    className=""
                    to={payment}
                    onClick={() => sendMetric('Medio de Pago')}
                  >
                    {converter.convertApaUnicode(
                      translationsMetadata,
                      'payment_selection_lbl',
                      'Medio de Pago',
                    )}
                  </NavLink>
                </li>
              )}
            </> */}
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={myProfile}
                onClick={() => {
                  sendMetric('Mi perfil');
                  closeMenu();
                }}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'my_profile',
                  'Mi perfil',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={count}
                onClick={() => {
                  sendMetric('Mis dispositivos');
                  closeMenu();
                }}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'my_devices',
                  'Mis dispositivos',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={parental}
                onClick={() => {
                  sendMetric('PIN de Protección');
                  closeMenu();
                }}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'access_code',
                  'Pin de Protección',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={history}
                onClick={() => {
                  sendMetric('Historial');
                  closeMenu();
                }}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'my_history',
                  'Historial',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={preference}
                onClick={() => {
                  sendMetric('Preferencias');
                  closeMenu();
                }}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'preferences',
                  'Preferencias',
                )}
              </NavLink>
            </li>
            <li className="menu-avatar-desktop__opt__admin">
              <NavLink
                to={help}
                onClick={() => {
                  sendMetric('Centro de ayuda');
                  closeMenu();
                }}
              >
                {converter.convertApaUnicode(
                  translationsMetadata,
                  'help_center',
                  'Centro de ayuda',
                )}
              </NavLink>
            </li>
            {showHboActivateOption && !isMobile && (
              <li className="menu-avatar-desktop__opt__admin">
                <button
                  type="button"
                  className="menu-avatar-desktop__opt__admin__action"
                  onClick={handleActivateHbo}
                >
                  {hboActivateOptionLabel}
                </button>
              </li>
            )}
          </>
        )}

        {!isKids && (
          <li
            className="menu-avatar-desktop__opt__admin"
            onClick={handleLogout}
          >
            <NavLink>
              {getTranslation('exit_btn_exit_txt', translations)}
            </NavLink>
          </li>
        )}
      </div>
    </>
  );
};
